<template>
<div class="body">
	
	404
</div>	
</template>
<script>
	export default{
		name:'Home',
		created(){
			this.$store.state.showFooter = false;

			
		},
		mounted(){
			this.$Utils.homeBottomView(true);
		},
		data(){
			return {
			
			}
		},
		mounted(){

		},
		methods:{
			
		}
	}
</script>
<style>
	
</style>


// WEBPACK FOOTER //
// pageNone.vue?7b5c4702